export default "__VITE_ASSET__BW1qF92Y__";